// `label` is shown in the staff CMS (dropdown when picking a section's topic) — kept
// as the plain category name so staff can tell at a glance what content goes where.
export const SECTION_TOPICS = [
  { value: 'einleitung', label: 'Einleitung' },
  { value: 'science', label: 'Science' },
  { value: 'risks', label: 'Risks' },
  { value: 'learning', label: 'Learning' },
  { value: 'ende', label: 'Ende' },
] as const

export type SectionTopic = (typeof SECTION_TOPICS)[number]['value']

export const SECTION_TOPIC_LABELS: Record<string, string> = Object.fromEntries(
  SECTION_TOPICS.map((t) => [t.value, t.label])
)

/** Persönliche Leseeinstellungen aus `user_profiles` - steuert, welche Abschnitte
 *  beim Lesen/Hören übersprungen werden. */
export type ReadingPrefs = {
  hideIntroSections?: boolean
  hideOutroSections?: boolean
}

export const NO_READING_PREFS: ReadingPrefs = {}

/** Ob ein Abschnitt wegen der Leseeinstellungen ausgeblendet bleibt. Der Haupttext
 *  eines Artikels zählt bewusst nicht dazu - nur eigenständige `einleitung`/`ende`-
 *  Abschnitte, denn sonst könnte ein Artikel ganz ohne sichtbaren Inhalt dastehen. */
export function isSectionHiddenByPrefs(
  topic: string | null | undefined,
  prefs: ReadingPrefs
): boolean {
  if (prefs.hideIntroSections && topic === 'einleitung') return true
  if (prefs.hideOutroSections && topic === 'ende') return true
  return false
}

// Reader-facing display copy, shown as the small eyebrow above each section's content.
export const SECTION_DISPLAY_LABELS: Record<string, string> = {
  einleitung: 'Ein Moment für dich',
  science: 'Dein Körper verstehen',
  risks: 'Was passieren kann',
  learning: 'Was jetzt zählt',
  ende: 'Du bist eine tolle Mutter',
}
